import { Dictionary } from '@feedyou/schema'

export const STORAGE_PERMITTED_SYMBOLS = '@:._-'

export const SYSTEM_STORAGE_NAMES = [
  'user-device',
  'user-device.client.browser',
  'user-device.client.name',
  'user-device.client.version',
  'user-device.client.engine',
  'user-device.client.engineVersion',
  'user-device.os.name',
  'user-device.os.version',
  'user-device.os.platform',
  'user-device.device.type',
  'user-device.device.brand',
  'user-device.device.model',
  'user-device.bot',
  'referrer-url',
  'user-id',
  'user-name',
  'user-phone-type',
  'last-name',
  'first-name',
  'first-name-vocative',
  'first-name-vocative-with-space-prefix',
  'first-name-vocative-with-comma-prefix',
  'first-name-with-space-prefix',
  'first-name-with-comma-prefix',
  'a-when-female',
  'address@base64',
  'channel',
  'locale',
  'test-mode',
  'gender',
  'email',
  'last-message-payload',
  'conversation-id',
  'last-message-text',
  'facebook-page-id',
  'call-type',
  'user-phone',
  'nlp-intent-name'
]

export const STATIC_READONLY_STORAGE_NAMES = [
  'first-name-vocative',
  'first-name-vocative-with-space-prefix',
  'first-name-vocative-with-comma-prefix',
  'first-name-with-space-prefix',
  'first-name-with-comma-prefix',
  'referrer-url',
  'a-when-female',
  'address@base64',
  'user-id',
  'conversation-id',
  'facebook-page-id',
  'last-message-payload',
  'test-mode',
  'last-message-text',
  'channel',
  'last-trigger-value'
]

export const INTEGRATION_STORAGE_NAMES: Dictionary<string, Dictionary<string, string[]>> = {
  bitrix: {
    'crm-lead-add': ['bitrix-crm-lead-add']
  },
  cemap: {
    'counter-price': [
      'cemap-counter-price',
      'cemap-counter-price.success',
      'cemap-counter-price.result.price.min',
      'cemap-counter-price.result.price.max',
      'cemap-counter-price.code',
      'cemap-counter-price.message'
    ]
  },
  http: {
    get: ['http-get.success', 'http-get.status', 'http-get.body'],
    post: ['http-post.success', 'http-post.status', 'http-post.body'],
    patch: ['http-patch.success', 'http-patch.status', 'http-patch.body'],
    put: ['http-put.success', 'http-put.status', 'http-put.body'],
    delete: ['http-delete.success', 'http-delete.status', 'http-delete.body']
  },
  ruian: {
    'zip-to-house-number': [
      'ruian-address-id',
      'ruian-zip',
      'ruian-street-or-village-part',
      'ruian-village-or-part-query',
      'ruian-village-or-part',
      'ruian-address-gps-lat',
      'ruian-address-gps-lon',
      'ruian-address-village',
      'ruian-village-or-part-sjtskx',
      'ruian-village-or-part-sjtsky',
      'ruian-village-or-part-gps.latitude',
      'ruian-village-or-part-gps.longitude'
    ]
  },
  'password-generator': {
    'create-password': ['password-generator-create-password']
  },
  'pdf-generator': {
    'curriculum-vitae': ['pdf-generator-curriculum-vitae.url'],
    'attachments-merge': ['pdf-generator-attachments-merge.url'],
    'custom-document': ['pdf-generator-custom-document.url']
  },
  repository: {
    query: [
      'repository-query-tags',
      'repository-query-counts-by-tags',
      'repository-query-count',
      'repository-query-items'
    ],
    aggregate: ['repository-aggregate-sum', 'repository-aggregate-count'],
    get: ['repository-get-item']
  },
  'success-factors': {
    'successfactors-job-application': ['successfactors-job-application'],
    'show-requisitions': ['successfactors-requisition'],
    'job-application': ['successfactors-application'],
    'create-candidate': []
  },
  teamio: {
    'query-requisitions': [
      'teamio-found-requisitions-tags',
      'teamio-found-requisitions-counts-by-tags',
      'teamio-found-requisitions-count',
      'teamio-found-requisitions'
    ],
    'show-found-requisitions': [
      'teamio-chosen-id',
      'teamio-chosen-title',
      'teamio-chosen-name',
      'teamio-chosen-min-salary',
      'teamio-chosen-max-salary',
      'teamio-chosen-salary-unit'
    ],
    'aggregate-requisitions': [
      'teamio-aggregated-requisitions',
      'teamio-aggregated-requisitions-formatted'
    ],
    'find-requisition': ['teamio-find-requisition']
  }
}
